module.exports = __webpack_public_path__ + "static/media/bullet-in-pregatire.b628566e.png";